import { LoadingButton } from '@mui/lab';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  RESEND_TITLE_TO_SIGN,
  resendInvestmentTitleToSign
} from 'src/store/actions/investmentActions';
import useStyles from "../../../styles";

const ResendTitleSigningLinkButton = ({
  investmentId,
  buttonText = 'COMMON.RESEND_SIGNING_URL',
  ...rest
}) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loadingResendTitle = useSelector(
    isLoadingSelector([RESEND_TITLE_TO_SIGN.action])
  );

  const handleResendTitleSigningLink = useCallback(() => {
    dispatch(resendInvestmentTitleToSign(investmentId));
  }, [investmentId, dispatch]);

  return (
    <LoadingButton
      {...rest}
      variant="contained"
      color="primary"
      onClick={handleResendTitleSigningLink}
      loading={loadingResendTitle}
      loadingPosition="start"
      className={classes.buttons}
      startIcon={<RefreshIcon />}
    >
      {t(buttonText)}
    </LoadingButton>
  );
};

export default ResendTitleSigningLinkButton;

ResendTitleSigningLinkButton.propTypes = {
  investmentId: PropTypes.number.isRequired,
  buttonText: PropTypes.string
};